import { Component, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CIPXQuoteRequestIntakeForm, CIPXQuoteRequestIntakeFormStateBond, CIPXQuoteRequestIntakeFormStateBondDetailedQuestion } from '../intake-form.types';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { getQuestionsForLayout, getQuestionsForSection } from '../intake-form.helpers';

@Component({
  standalone: true,
  imports: [
    SharedModule,
    SharedComponentsModule
  ],
  selector: 'cipx-quote-request-intake-form-question-set',
  templateUrl: 'question-set.component.html'
})

export class CIPXQuoteRequestIntakeFormQuestionSetComponent implements OnInit, OnChanges {
  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;
  @Input() stateBond!: CIPXQuoteRequestIntakeFormStateBond | null;
  @Input() layoutName: string = 'unknown';

  questions = signal<CIPXQuoteRequestIntakeFormStateBondDetailedQuestion[]>([]);

  constructor() { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['quoteRequestForm'] && this.quoteRequestForm) {
      // form changed
    }
    if (changes['stateBond'] && this.stateBond) {
      const questions = getQuestionsForSection(this.layoutName, this.stateBond);
      this.questions.set(questions);
    }
  }

  getQuestionErrorText(question: CIPXQuoteRequestIntakeFormStateBondDetailedQuestion): string {
    if (question.question_error_text && question.question_error_text.length > 0) {
      return question.question_error_text;
    }
    if (question.question_help_text && question.question_help_text.length > 0) {
      return question.question_help_text;
    }
    return 'Required.';
  }

  getStandardizedQuestionType(question: CIPXQuoteRequestIntakeFormStateBondDetailedQuestion): string {
    const intTypes = ['integer', 'int', 'decimal', 'float', 'double', 'number'];
    if (intTypes.includes(question.question_type)) {
      return 'number';
    }
    return question.question_type;
  }
}
